export function parseLocalizedNumber(value: unknown): number {
  if (typeof value === "number") return value;
  if (typeof value !== "string") return Number.NaN;
  return Number(value.trim().replace(/\s/g, "").replace(",", "."));
}

export function formatDecimal(value: number, decimals = 2, locale = "vi-VN"): string {
  if (!Number.isFinite(value)) return "—";
  return value.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function escapeHtml(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function sanitizeColor(value: unknown): string {
  return /^#[0-9a-f]{6}$/i.test(String(value ?? "")) ? String(value) : "#6b7280";
}
